import { createSlice } from '@reduxjs/toolkit';
import { difference, union } from 'es-toolkit';

import { fetchSellerDetailsByIds } from '@/redux/modules/seller/details/sellerDetails.actions';
import { defaultSellerDetailsSlice } from '@/redux/modules/seller/details/sellerDetails.types';

const sellerDetailsSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(fetchSellerDetailsByIds.pending, (slice, { meta }) => {
            slice.loading = union(slice.loading, meta.arg);
        });
        builder.addCase(fetchSellerDetailsByIds.fulfilled, (slice, { meta, payload }) => {
            if (payload?.length) {
                payload.forEach((sellerDetails) => {
                    slice.byId[sellerDetails.sellerId] = sellerDetails;
                    slice.loaded[sellerDetails.sellerId] = Date.now();
                });
                slice.loading = difference(slice.loading, meta.arg);
            }
        });
        builder.addCase(fetchSellerDetailsByIds.rejected, (slice, { meta }) => {
            slice.loading = difference(slice.loading, meta.arg);
        });
    },
    initialState: defaultSellerDetailsSlice,
    name: 'sellerDetails',
    reducers: {},
});

export const { reducer: sellerDetailsReducer } = sellerDetailsSlice;
